import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Overview from './pages/Overview.jsx';
import Subscription from './pages/Subscription.jsx';

export default function Routes() {
  return (
    <Switch>
      <Route
        path={[
          '/subscription/:subscriptionId/(.*)',
          '/subscription/:subscriptionId',
        ]}
      >
        <Subscription />
      </Route>
      <Route path="/">
        <Overview />
      </Route>
    </Switch>
  );
}
